import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NavDataService } from 'src/app/services/nav-data.service';

import { SolicitarVisitaService } from 'src/app/services/solicitar-visita.service';
import { StorageService } from 'src/app/services/storage.service';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

// Interfaz para la compañía seleccionada, para mayor claridad
interface SelectedCompany {
  id: number;
  nombre: string;
}

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [AppHorizontalNavItemComponent, CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit, OnDestroy {
  navItems: NavItem[] = [];
  parentActive = '';
  hasPendingRequests = 0;
  
  // 1. Crea la propiedad para almacenar la compañía seleccionada
  private selectedCompany: SelectedCompany | null = null;
  
  private subscriptions: Subscription = new Subscription();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public navService: NavService,
    public router: Router,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private navDataService: NavDataService,
    private solicitarVisitaService: SolicitarVisitaService,
    private storage: StorageService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    
    // Mantenemos esto para la clase activa del menú
    const routerSubscription = this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
    this.subscriptions.add(routerSubscription);
  }

  ngOnInit(): void {
    // 2. Suscríbete para obtener el menú dinámico
    const navSubscription = this.navDataService.navItems$.subscribe(items => {
      this.navItems = items;
    });
    this.subscriptions.add(navSubscription);

    // 3. Suscríbete para obtener el usuario y ASIGNAR la compañía seleccionada
    const userSubscription = this.storage.user$.subscribe(user => {
      if (user && user.selectedCompany) {
        this.selectedCompany = user.selectedCompany;
        // 4. Llama al método que carga el contador, AHORA que ya tienes la compañía
        this.loadPendingRequests(); 
      }
    });
    this.subscriptions.add(userSubscription);
  }

  /**
   * 5. Nuevo método encapsulado para cargar el contador de pendientes.
   * Este método ahora confía en que `this.selectedCompany` ya está definido.
   */
  private loadPendingRequests(): void {
    if (!this.selectedCompany) {
      return;
    }

    const isGruman = this.selectedCompany.nombre.toLowerCase().trim() === 'gruman';
    // Si es Gruman, el clientId es undefined para contarlas todas.
    // Si no, se usa el id de la compañía seleccionada.
    const clientId = isGruman ? undefined : this.selectedCompany.id;

    const pendingRequestsSubscription = this.solicitarVisitaService.getPendingRequestsCount(clientId).subscribe((count: number) => {
      this.hasPendingRequests = count;
    });

    // Agregamos esta suscripción al gestor principal para limpiarla después
    this.subscriptions.add(pendingRequestsSubscription);
  }

  ngOnDestroy(): void {
    // Con una sola línea nos desuscribimos de todo
    this.subscriptions.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}